<!--
  - Copyright (C) 2025. Archimedes Exhibitions GmbH,
  - Saarbrücker Str. 24, Berlin, Germany
  -
  - This file contains proprietary source code and confidential
  - information. Its contents may not be disclosed or distributed to
  - third parties unless prior specific permission by Archimedes
  - Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
  - to copies made in any form and using any medium. It applies to
  - partial as well as complete copies.
  -->

<template>
  <div
    style="height: 100vh; width: 100vw; overflow: hidden; margin: 0; padding: 0;">
    <b-container class="py-4" fluid style="height: 100%; width: 100%;">
      <iframe
        :key="'extension'+extensionKey"
        v-if="extensionURL"
        :src="extensionURL"
        style="width: 100%; height: 100%; border: none;"
        allowfullscreen>
      </iframe>
      <h2 v-else>URL for {{ this.$route.params.extensionID }} could not be found!</h2>
    </b-container>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'extensions',
    components: {},

    data () {
      return {
        extensionKey: 0
      }
    },

    watch: {
      '$route' (newRoute, _) {
        // Reload frame hack
        if (Object.keys(newRoute.query).length === 0) {
          this.extensionKey++
        }
      }
    },

    computed: {
      extensions () {
        if (Vue.prototype.$EXTENSIONS) {
          return Vue.prototype.$EXTENSIONS
        }
        return []
      },
      extensionURL () {
        const entry = this.extensions.find(entry => entry.extensionID === this.$route.params.extensionID)
        if (!entry) {
          return null
        }
        return entry.url
      }
    },

    methods: {
      handleIframeMessage (event) {
        if (typeof event.data === 'object' && event.data.param) {
          const newQuery = { ...this.$route.query }
          newQuery[event.data.param] = JSON.stringify(event.data.value)
          this.$router.push({ query: newQuery }).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
      }
    },

    mounted () {
      window.addEventListener('message', this.handleIframeMessage)
    },

    beforeDestroy () {
      window.removeEventListener('message', this.handleIframeMessage)
    }
  }
</script>

<style scoped></style>
